import { render, staticRenderFns } from "./TypeFormLeads.vue?vue&type=template&id=3fa8f53b&scoped=true&"
import script from "./TypeFormLeads.vue?vue&type=script&lang=js&"
export * from "./TypeFormLeads.vue?vue&type=script&lang=js&"
import style0 from "./TypeFormLeads.vue?vue&type=style&index=0&id=3fa8f53b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa8f53b",
  null
  
)

export default component.exports